<template>
  <div class="ratings">
    <div
      v-if="rating"
      class="flex flex-col items-start"
    >
      <!-- star icons -->
      <div class="stars flex justify-center items-center">
        <span
          v-for="(type, i) in stars"
          :key="i"
        >
          <!-- full star -->
          <span
            v-if="type === 'full'"
            class="text-primary-charlie text-xl mr-0.5"
          >★</span>

          <!-- half star -->
          <span
            v-else-if="type === 'half'"
            class="relative text-gray-200 text-xl mr-0.5"
          >
            <span class="absolute top-[-3px] left-0 overflow-hidden w-1/2 text-primary-charlie">
              ★
            </span>
            ★
          </span>

          <!-- empty star -->
          <span
            v-else
            class="text-gray-200 text-xl mr-0.5"
          >★</span>
        </span>

        <strong class="ml-2">{{ rating.averageUserRating.toFixed(1) }}</strong>
      </div>

      <!-- numeric display -->
      <div class="mt-1">
        <small class="text-sm text-gray-500">
          ({{ formatCount(rating.userRatingCount) }} beoordelingen)
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayStoreRating',
  data() {
    return {
      // still hard‑coded for now
      rating: {
        averageUserRating: 4.7,
        userRatingCount: 1346
      }
    };
  },
  computed: {
    stars() {
      const fullStars = Math.floor(this.rating.averageUserRating);
      const hasHalf = (this.rating.averageUserRating - fullStars) >= 0.5;
      const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

      return [
        ...Array(fullStars).fill('full'),
        ...(hasHalf ? ['half'] : []),
        ...Array(emptyStars).fill('empty')
      ];
    }
  },
  methods: {
    formatCount(n) {
      return n > 1000
        ? (n / 1000).toFixed(1) + 'k'
        : n;
    }
  }
};
</script>
